import React from 'react';
import LBlist from "./Model/LBlist";
class Home extends React.Component{

  state={
    regionIdMd:""
 }

  componentDidMount(){
      //regionIdMd 加密后regionIdMd
    let regionIdMd = this.props.match.params.id;
     this.setState({
       regionIdMd:regionIdMd
     })
  }
  render(){

    return(
        <div>
         <LBlist regionIdMd={this.state.regionIdMd}/>
          </div>
    )
  }
}

export default Home;


// WEBPACK FOOTER //
// ./src/components/Home.js